import { SET_LOGIN_STATE, SET_USER_INFO } from './mutation-types'

const app = {
  // 全局状态
  state: {
    // 用户信息
    userInfo: {},
    isLogin: false,
  },
  // getters是对数据的包装，例如对数据进行拼接，或者过滤
  getters: {
    //类似于计算属性
    getUserPhoto(state) {
      if (state.isLogin) {
        if (state.userInfo.photoUrl) {
          return state.userInfo.photoUrl
        } else {
          return 'https://gitee.com/moxi159753/wx_picture/raw/master/picture/favicon.png'
        }
      } else {
        return '../../static/images/defaultAvatar.png'
      }
    },
  },
  // 如果我们需要更改store中的状态，一定要通过mutations来进行操作
  mutations: {

    // 传入自定义参数
    [SET_USER_INFO](state, userInfo) {
      state.userInfo = userInfo
    },
    [SET_LOGIN_STATE](state, isLogin) {
      if (isLogin) {
        localStorage.setItem('isLogin', '1')
      } else {
        localStorage.removeItem('isLogin')
      }
      state.isLogin = isLogin
    },
  },

  // actions是我们定义的一些操作，正常情况下，我们很少会直接调用mutation方法来改变state
  actions: {},
}
export default app
